const YOUTUBE = "__YOUTUBE";

const talks = [
    {
        type: YOUTUBE,
        youtubeEmbed: "https://www.youtube.com/embed/g3hNwmdmGcM",
        youtubeLink: "https://www.youtube.com/watch?v=g3hNwmdmGcM",
        title:
            "Innovate with petabyte-scale open data in the life sciences",
        byline: "Brock Wester",
        venue: "AWS DC Summit, May 2022"
    },

    {
        type: YOUTUBE,
        youtubeEmbed: "https://www.youtube.com/embed/Et7GFl-sqnA",
        youtubeLink: "https://www.youtube.com/watch?v=Et7GFl-sqnA",
        title:
            "SABER: Scalable Analytics for Brain Exploration Research",
        byline: "Erik Johnson, Daniel Xenes, William R. Gray Roncal",
        venue: "CWL Conference 2021"
    },

    {
        type: YOUTUBE,
        youtubeEmbed: "https://www.youtube.com/embed/UhIuK5ty9Ww",
        youtubeLink: "https://www.youtube.com/watch?v=UhIuK5ty9Ww",
        title: "Getting started with Serverless Architectures",
        byline: "Sandy Hider",
        venue: "AWS Public Sector Summit, June 2019"
    },

    {
        type: YOUTUBE,
        youtubeEmbed: "https://www.youtube.com/embed/ldNqVmW9c98",
        youtubeLink: "https://www.youtube.com/watch?v=ldNqVmW9c98",
        title:
            "The Boss: A Petascale Database for Large-Scale Neuroscience, Pow (DAT401)",
        byline: "Dean Kleissas",
        venue: "AWS Public Sector Summit, December 2017"
    },

    {
        type: YOUTUBE,
        youtubeEmbed: "https://www.youtube.com/embed/806a3x2s0CY",
        youtubeLink: "https://www.youtube.com/watch?v=806a3x2s0CY",
        title:
            "The Boss: A Petascale DB for Large-Scale Neuroscience Powered by Serverless Advanced Technologies",
        byline: "Dean Kleissas",
        venue: "AWS Public Sector Summit, June 2017"
    },
];

export default talks;
